import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import ProjectIntro from "../a_sections/ProjectIntro";
import SanityImage from "gatsby-plugin-sanity-image";
// import ProjectIndex from "../a_sections/ProjectIndex";
// import { motion, AnimatePresence } from "framer-motion";
// import { GatsbyImage } from "gatsby-plugin-image";

export default function Header({
  selectedProject,
  navOn,
  isMobile,
  selectedRole,
  pageContext,
  handleProjectChange,
  handleMouseOutNav,
  projectClick,
  navDuration,
  navEase,
  projectState,
  windowSize,
}) {
  const data = useStaticQuery(graphql`
    query HomeQuery {
      allSanityProject(sort: { orderRank: ASC }) {
        nodes {
          projectName
          roleTagArray {
            name
            id
          }
          press {
            url
            name
          }
          heroImageDarken
          heroImage {
            image {
              ...Image
              asset {
                gatsbyImageData(formats: NO_CHANGE)
                width
                metadata {
                  lqip
                }
              }
            }
          }

          description
          clientTag {
            name
          }
          roleTagArray {
            name
          }
          blurb
          awards {
            url
            name
          }
          slug {
            current
          }
          _id
          mediumTagArray {
            name
          }
          madeAt
        }
      }
    }
  `);

  const s = data.allSanityProject.nodes;

  const roleFilteredProjects = s.filter((node) =>
    selectedRole === "All"
      ? s
      : node.roleTagArray.some((role) => role.name === selectedRole)
  );

  const headerData = navOn ? roleFilteredProjects : s;

  return (
    <>
      <section>
        <div
          className=" absolute h-[0px] w-[0px] overflow-hidden bg-red-500"
          id="imageStack"
        >
          {s.map((project) => (
            <React.Fragment key={project._id}>
              {project.heroImage && (
                <SanityImage
                  {...project.heroImage.image}
                  width={windowSize}
                  config={{ quality: 100 }}
                  alt={""}
                />
              )}
            </React.Fragment>
          ))}
        </div>
        {headerData.map((project) => (
          <React.Fragment key={project._id}>
            {project.slug.current === selectedProject || isMobile & navOn ? (
              <ProjectIntro
                projectState={projectState}
                windowSize={windowSize}
                navEase={navEase}
                navDuration={navDuration}
                heroImageDarken={project.heroImageDarken}
                isMobile={isMobile}
                madeAt={project.madeAt}
                key={project._id}
                slug={project.slug.current}
                navOn={navOn}
                name={project.projectName}
                client={project.clientTag ? project.clientTag.name : ""}
                blurb={project.blurb}
                desc={project.description}
                heroImage={project.heroImage ? { ...project.heroImage.image } : false}
                awards={project.awards}
                press={project.press}
                roles={project.roleTagArray}
                mediums={project.mediumTagArray}
                handleProjectChange={handleProjectChange}
                projectClick={projectClick}
                handleMouseOutNav={handleMouseOutNav}
              ></ProjectIntro>
            ) : null}
          </React.Fragment>
        ))}
      </section>
    </>
  );
}
